<template>
  <!-- ふせんの解答 ここから-->
  <div>
    <button
      type="button"
      :disabled="modal"
      class="btn btn-default btn-lg btn-block btn-fusen"
      :class="{ 'btn-fusen-yes': this.selected === true }"
      @click="correct"
    >
      できた
    </button>
    <button
      type="button"
      :disabled="modal"
      class="btn btn-default btn-lg btn-blFock btn-fusen"
      :class="{ 'btn-fusen-yes': this.selected === false }"
      @click="fault"
    >
      できなかった
    </button>
  </div>
  <!-- ふせんの解答 ここまで-->
</template>

<script>
export default {
  data() {
    return {
      selected: null
    };
  },
  mounted() {
    // eslint-disable-next-line no-console
    console.log("mounted");
    if ((this.response === true || this.response === false) && this.sent) {
      this.selected = this.response;
    }
  },
  methods: {
    correct() {
      this.selected = true;
    },
    fault() {
      this.selected = false;
    }
  },
  computed: {
    response() {
      return this.$store.getters.response;
    },
    sent() {
      return this.$store.getters.sent || this.$store.state.modal;
    },
    modal() {
      return this.$store.state.modal;
    },
    question() {
      return this.$store.getters.question;
    }
  },
  watch: {
    selected(nv) {
      this.$store.commit("setResponse", {
        response: nv,
        correct: nv
      });
      this.$emit('setSend');
    }
  }
};
</script>

<style scoped>
.btn-fusen {
  display: block;
  margin: 2rem auto;
  width: 9em;
  font-size: 1.5rem;
  line-height: 2.5rem;
  border-radius: 4rem;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  -webkit-box-shadow: 3px 3px 15px 3px rgba(0, 0, 0, 0.1);
  box-shadow: 3px 3px 15px 3px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.2em;
  border: none;
}

.btn-fusen:disabled {
  opacity: 1;
}

.btn-fusen.btn-fusen-yes {
  background-color: #3553a7;
  color: #fff;
  border: none;
}
</style>
